import { Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs/BehaviorSubject";
import { Subject } from "rxjs/Subject";

import { MediwareHubService } from "../mediware-hub/mediware-hub";
import { SessionProvider } from "../session/session";
import { Appointment, AppointmentQuery } from "../../mediware-interfaces";
import { NAME_APP_NO_AVAILABLE, SALA_ESPERA_POLL_INTERVAL_MS } from "../../constants";

/* Consulta periodicamente los turnos del medico logueado y expone
   los que estan en sala de espera (estado "S"), para poder avisar
   al medico sin que tenga que refrescar la pantalla */
@Injectable()
export class SalaEsperaProvider {
  pacientesEnEspera$ = new BehaviorSubject<Appointment[]>([]);
  nuevosIngresos$ = new Subject<Appointment[]>();
  actualizando$ = new BehaviorSubject<boolean>(false);

  private _pollInterval: any = null;
  private _idsConocidos: Set<number> = new Set();
  private _consultando: boolean = false;

  constructor(
    private mediwareHubService: MediwareHubService,
    private session: SessionProvider,
  ) {}

  iniciarPolling(): void {
    if (this._pollInterval) {
      return;
    }
    this._consultarSalaDeEspera();
    this._pollInterval = setInterval(() => {
      this._consultarSalaDeEspera();
    }, SALA_ESPERA_POLL_INTERVAL_MS);
  }

  detenerPolling(): void {
    if (this._pollInterval) {
      clearInterval(this._pollInterval);
      this._pollInterval = null;
    }
    this._idsConocidos.clear();
    this.pacientesEnEspera$.next([]);
  }

  //fuerza una consulta inmediata, sin esperar al proximo tick del polling
  //(la usan tanto el boton de refrescar como la entrada a Medical History)
  actualizarAhora(): void {
    this._consultarSalaDeEspera();
  }

  private _consultarSalaDeEspera(): void {
    if (!this.session.isActive() || this._consultando) {
      return;
    }
    this._consultando = true;
    this.actualizando$.next(true);

    const hoy = new Date();
    this.mediwareHubService.getAppointments(hoy, hoy).subscribe(
      (resp: AppointmentQuery) => {
        this._consultando = false;
        this.actualizando$.next(false);
        const enEspera = this._filtrarSalaDeEspera(resp);

        const nuevos = enEspera.filter((a) => !this._idsConocidos.has(a.id));

        this._idsConocidos = new Set(enEspera.map((a) => a.id));
        this.pacientesEnEspera$.next(enEspera);

        if (nuevos.length) {
          this.nuevosIngresos$.next(nuevos);
        }
      },
      (err) => {
        this._consultando = false;
        this.actualizando$.next(false);
        console.log("SalaEsperaProvider: error consultando sala de espera", err);
      },
    );
  }

  private _filtrarSalaDeEspera(resp: AppointmentQuery): Appointment[] {
    if (!resp) {
      return [];
    }
    const clavesNumericas = Object.keys(resp).filter((key) => /^\d+$/.test(key));
    return clavesNumericas
      .map((key) => resp[key] as Appointment)
      .filter(
        (a) =>
          a &&
          a.estado &&
          a.estado.toUpperCase() === "S" &&
          a.apellido &&
          a.apellido.toUpperCase() !== NAME_APP_NO_AVAILABLE,
      )
      .sort((a, b) => a.hora.localeCompare(b.hora));
  }
}



// WEBPACK FOOTER //
// ./src/providers/sala-espera/sala-espera.ts